import React from "react";
import {FormattedMessage} from 'react-intl';

import zonizLogo from "../assets/img/icon_zoniz_black.svg";
import {findMobileOperatingSystemAndGetLink} from "../util/common";

function BrandingWatermark() {
    return (
        <div className="branding-watermark">
          <div className="row msg-row">
              <h3>{<FormattedMessage id="OnlineMenuOfferedByZoniz"/>}</h3>
          </div>
            <div className="row logo-row">
                <a target="blank" href={findMobileOperatingSystemAndGetLink()}><img alt="zoniz logo" src={zonizLogo}/></a>

            </div>
        </div>
    );
}

export default BrandingWatermark;
